"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=Announced.types.js.map